import { resourceState, resourceMutations } from '@/store/utils/resource';
import { clientSalesOrdersClient as client } from '@/api/clients/admin';
import { ORDERS } from '@/store/entities/schema_types';

export default {
  namespaced: true,

  state: resourceState(),

  mutations: resourceMutations,

  getters: {
    salesOrders(state, _, rootState) {
      return state.ids.map((id) => rootState.entities.orders.byId[id]);
    },
  },

  actions: {
    async load(ctx, { clientUuid, params = {} } = {}) {
      try {
        const response = await client.list(clientUuid, { params });
        const { data: payload } = response;
        const { data, meta, links } = payload;

        const salesOrderUuids = await ctx.dispatch(
          'entities/persistEntities',
          { type: ORDERS, data },
          { root: true }
        );

        ctx.commit('setIds', salesOrderUuids);
        ctx.commit('setMeta', meta);
        ctx.commit('setLinks', links);

        return Promise.resolve(true);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
